import axios from 'helpers/axios';

export default (url = '', method = 'get', postBody = {}) => {
  const requestParams = [url, method === 'post' ? { ...postBody } : {}];
  return axios[method.toLowerCase()](...requestParams);
};
